module.exports = "https://static.wanderu.com/ui-react/_next/static/media/intercom.7144f74f.svg";